import React from "react";
import styles from "./index.module.scss";

interface QuestionBlockHeaderProps {
    type: string;
    totalScore: number;
    score: number;
    auto: boolean;
}

export function QuestionBlockHeader({
    type,
    totalScore,
    score,
    auto
}: QuestionBlockHeaderProps) {
    return (
        <div className={styles.root}>
            <span className={styles.type}>{type}</span>
            <span className={styles.totalScore}>(本小题{totalScore}分)</span>

            <div className={styles.right}>
                <span className={styles.score}>本题得分{score}</span>
                {auto && <span className={styles.auto}>系统自动判分</span>}
            </div>
        </div>
    );
}
